<template>
  <div>
    <el-select
      v-close-on-zoom
      :value="state.selectedNpcKey"
      placeholder="Select VIP"
      :disabled="readonly"
      class="npc-select"
      @input="selectNpc"
    >
      <el-option
        v-for="npc in activeNpcs(emitter.caseConf)"
        :key="npc.key"
        :label="npcLabel(npc)"
        :value="npc.key"
      />
    </el-select>
    <toggle-dialogue-effect
      effect-type="NPC"
      :placeholder="type === 'NPC_COMMAND' ? 'VIP' : 'VIP question'"
      :no-data-text="type === 'NPC_COMMAND' ? 'No commands to enable/disable' : undefined"
      :get-dialogue-items="getSelectedNpcItems"
      :put-data="putDataWithNpcData"
      v-bind="$props"
    />
  </div>
</template>

<script>
import get from 'lodash/get';

import { npcLabel } from '~lib/common/utils/labels';
import { activeNpcs } from '~lib/common/utils/npc';

import ToggleDialogueEffect from './ToggleDialogueEffect.vue';

export default {
  name: 'toggle-npc-effect',
  components: {
    ToggleDialogueEffect,
  },
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control', 'type', 'value'],
  data() {
    return {
      state: {
        selectedNpcKey: null,
      },
    };
  },
  computed: {
    selectedNpc() {
      const npcs = this.emitter.caseConf.npcs || [];
      return npcs.find(npc => npc.key === this.state.selectedNpcKey);
    },
  },
  created() {
    const data = this.getData(this.ikey);
    this.state.selectedNpcKey = get(data, 'npcKey');
  },
  mounted() {
    this.emitter.trigger('process', this.control);
  },
  methods: {
    selectNpc(npcKey) {
      this.state.selectedNpcKey = npcKey;
      // First time selecting an npc, we don't want to emit null id and cause validation errors
      if (!this.getData(this.ikey)) {
        return;
      }
      this.putDataWithNpcData(this.ikey, {});
    },
    putDataWithNpcData(key, data) {
      this.putData(key, {
        ...data,
        type: this.type,
        value: this.value,
        npcKey: this.state.selectedNpcKey,
      });
      this.emitter.trigger('process', this.control);
    },
    getSelectedNpcItems() {
      if (!this.selectedNpc) {
        return [];
      }
      const dialogue = this.selectedNpc.dialogue || {};
      if (this.type === 'NPC_COMMAND') {
        return dialogue.commands;
      } else {
        return dialogue.questions;
      }
    },
    npcLabel,
    activeNpcs,
  },
};
</script>

<style scoped>
</style>